import { Store } from 'src/store/index';

const getTotalPagesCount = (store: Store) => store.design.totalPagesCount;

export default getTotalPagesCount;
